import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';

import {
    withStyles, Grid, Typography,
} from '@material-ui/core';

import Header from './components/Header';
import { Loading } from '../../youwell-common/components';
import { gridLayout } from '../../common/constants';

import ErrorDescription from './components/ErrorDescription';

const styles = theme => ({
    root: {
    },
    header: {

    },
    content: {
        background: theme.palette.common.white,
    },
    printFooter: {
        padding: theme.spacing(5, 0),
        width: '100%',
        display: 'none',

        '@media print': {
            display: 'block',
        },
    },
});

class Layout extends React.Component {
    render() {
        const {
            classes, children, loading, errorMessage, studentId,
        } = this.props;

        return (
            <>
                <Loading loading={loading} />
                <Grid container justifyContent="center" className={classes.root}>
                    <Grid item xs={12} className={classes.header}>
                        <Grid container justifyContent="center">
                            <Grid item {...gridLayout}>
                                <Header studentId={studentId} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item {...gridLayout} className={classes.content}>
                        <ErrorDescription errorMessage={errorMessage} />
                        {children}
                    </Grid>
                </Grid>
                <div className={classes.printFooter}>
                    <Typography variant="subtitle1" display="block" align="center">
                        <Translate id="footer.copyright" />
                    </Typography>
                </div>
            </>
        );
    }
}

Layout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    classes: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    errorMessage: PropTypes.string,
    studentId: PropTypes.string,
};

Layout.defaultProps = {
    children: null,
    loading: false,
    errorMessage: null,
    studentId: null,
};

const mapStateToProps = state => ({
    loading: state.auth.loading || state.patient.loading || state.program.loading || state.teacher.loading,
    errorMessage: [].concat(state.auth.errors, state.patient.errors, state.program.errors, state.teacher.errors).filter(val => val).join('<br/>'),
});


export default connect(mapStateToProps)(withStyles(styles)(Layout));
